var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"o-itemList",class:{isSpread: _vm.isSpread}},_vm._l((_vm.items),function(item){return _c('div',{key:item.id,staticClass:"o-item",class:{
      isMarking: item.isMarking,
    }},[_vm._v(_vm._s(_vm.displayName(item)))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }